import { unregisterBrazeServiceWorker as unregisterBrazeSW } from '../../braze'

export function unregisterBrazeServiceWorker() {
  return unregisterBrazeSW()
}
